import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function EyeOffIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M7.234 4.162q.371-.05.766-.05c3.111 0 5.153 2.502 5.84 3.492.082.12.124.18.147.272a.6.6 0 0 1 0 .248c-.023.093-.065.153-.149.274a10 10 0 0 1-.83 1.036m-8.224-4.37c-1.318.815-2.212 1.947-2.623 2.539-.083.12-.125.18-.148.273a.6.6 0 0 0 0 .248c.023.092.065.152.148.272.686.99 2.728 3.493 5.839 3.493 1.255 0 2.335-.407 3.223-.958M2.515 3l10.97 10M6.708 6.821c-.33.302-.535.719-.535 1.179 0 .92.818 1.667 1.828 1.667.505 0 .962-.187 1.293-.488" /></svg>
  );
}

export default EyeOffIcon;
